module.exports = __webpack_public_path__ + "static/media/manufacturing-macrovector_oficial-01 12.ffff590c.png";